import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import {
  AMENITY_FORM_NO,
  AMENITY_FORM_UNKNOWN,
  AMENITY_FORM_YES,
  AMENITY_UNKNOWN_SELECTION_HINT,
  getAmenitySaveHint,
} from './amenityOverrideUtils';

function AmenityInput({
  amenityKey,
  amenityType,
  formValue,
  onChange,
}) {
  const handleSelectionChange = React.useCallback(
    (_event, nextValue) => {
      if (nextValue !== null) {
        onChange(amenityKey, nextValue);
      }
    },
    [amenityKey, onChange],
  );

  const selectionHint = formValue === AMENITY_FORM_UNKNOWN
    ? AMENITY_UNKNOWN_SELECTION_HINT
    : `Saves as: ${getAmenitySaveHint(formValue, amenityType)}`;

  return (
    <Grid item xs={12} md={6}>
      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
        {amenityType.label}
      </Typography>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={formValue}
        onChange={handleSelectionChange}
        aria-label={`${amenityType.label} override`}
        sx={{ mb: 0.5 }}
      >
        <ToggleButton value={AMENITY_FORM_UNKNOWN} aria-label={`${amenityType.label} unknown`}>
          Unknown
        </ToggleButton>
        <ToggleButton value={AMENITY_FORM_YES} aria-label={`${amenityType.label} yes`}>
          Yes
        </ToggleButton>
        <ToggleButton value={AMENITY_FORM_NO} aria-label={`${amenityType.label} no`}>
          No
        </ToggleButton>
      </ToggleButtonGroup>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
        {selectionHint}
      </Typography>
    </Grid>
  );
}

AmenityInput.propTypes = {
  amenityKey: PropTypes.string.isRequired,
  amenityType: PropTypes.shape({
    label: PropTypes.string.isRequired,
    antiLabel: PropTypes.string.isRequired,
    displayAnti: PropTypes.bool,
  }).isRequired,
  formValue: PropTypes.oneOf([
    AMENITY_FORM_YES,
    AMENITY_FORM_NO,
    AMENITY_FORM_UNKNOWN,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AmenityInput;
